
import { apiFetch } from './client';
import type { Skill } from '../types/contracts';

export const skillsApi = {
  list:         ()              => apiFetch<Skill[]>('/api/skills'),
  getForAgent:  (id: string)   => apiFetch<Skill[]>(`/api/skills/agent/${id}`),
};
